// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__29rF9","close":"styles_close__3unLG","btn-cancel":"styles_btn-cancel__3IyVg"};